/* global __API_DOMAIN__ */
export const API_DOMAIN = __API_DOMAIN__;
